import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogData } from "../cookie-dialog.component";

// Fenêtre « Personnaliser » : une case par finalité, décochées tant que l'utilisateur n'a rien accepté
@Component({
    selector: 'dialog-content-example-dialog',
    templateUrl: 'dialog-content-example-dialog.html',
    styleUrls: ['dialog-content-example-dialog.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogContentExampleDialog {

  constructor(public dialogRef: MatDialogRef<DialogContentExampleDialog, DialogData>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  rejectAll(): void {
    this.dialogRef.close({ analytics: false, ads: false });
  }

  acceptAll(): void {
    this.dialogRef.close({ analytics: true, ads: true });
  }

  save(): void {
    this.dialogRef.close({ analytics: !!this.data.analytics, ads: !!this.data.ads });
  }
}
